/**
 * Rooms List Controller
 * used in the rooms route for displaying available rooms for the session
*/
angular.module('bookingApp')
    .controller('roomsListController',function($scope, sessionFactory, propertyFactory, appFactory, $http, $filter, $routeParams){
    $scope.session = sessionFactory;
    $scope.property = propertyFactory;
    $scope.baseApp = appFactory;
    $scope.baseApp.controls.type = 'cart-back-forwards';
    sessionFactory.viewingRoom = $routeParams.id;
    sessionFactory.viewingPhoto = 0;
    $scope.roomsHaveBeenLoaded = false;
    propertyFactory.showRedirectConfirm = true;
    $scope.loadingLimit = 10;
    $scope.closedFrom = null;
    $scope.closedTo = null;

    $scope.goToRoom = function(index){
        $scope.goToPage('room/'+index);
    };

    // setup footer controls
    $scope.setupStandardCartFooter();
    $scope.footer.nextFunc = function(){
        $scope.goToPage('cart');
    };





    $scope.$watch('session.propertyCloseDates', function(newVal, oldVal){
        if(sessionFactory.propertyCloseDates.hasOwnProperty('previous')) {
            $scope.closedFrom =  ((moment(sessionFactory.propertyCloseDates.previous.date).add(1, 'days')).toDate());
        } else {
            $scope.closedFrom = null;
        }
        if(sessionFactory.propertyCloseDates.hasOwnProperty('after')){
            $scope.closedTo = ((moment(sessionFactory.propertyCloseDates.after.date).subtract(1,'days')).toDate());
        } else {
            $scope.closedTo = null;
        }
        $scope.safeApply();
    }, true);
    $scope.getClass = function(iconId){
        var iconClass = '';
        switch(iconId){
            case 0:
                iconClass = 'f-tv';
                break;
            case 1:
                iconClass = 'f-internet';
                break;
            case 2:
                iconClass = 'f-safe';
                break;
            case 3:
                iconClass = 'f-aircon';
                break;
            case 4:
                iconClass = 'f-phone';
                break;
            case 5:
                iconClass = 'f-disabled';
                break;
            case 6:
                iconClass = 'f-coffee';
                break;
            case 7:
                iconClass = 'f-spa';
                break;
        }
        return iconClass;
    };
    $scope.getShowPrice = function(room){
        var basePax = propertyFactory.prices[room][0].basePax,
            start = sessionFactory.selectedFilters.checkin,
            end = sessionFactory.selectedFilters.checkout,
            range = moment.range(start, end),
            paxConfig;

        // If the base pax is zero then this is probably a per-pax rate. We'll force it to one adult for the individual
        // adult price
        if(basePax < 1) {
            basePax = 1;
        }

        paxConfig = RoomRatePricing.buildPaxConfiguration(basePax,0,0);

        return RoomRatePricing.getPerPeriodAndTotalPrice(propertyFactory.prices[room],paxConfig, range, 1).perPeriod;
    };
    $scope.getInitialRooms = function(){
        if(propertyFactory.rooms === null || propertyFactory.rooms.length <= 0 || sessionFactory.forceRoomRefresh){
            if(sessionFactory.forceRoomRefresh){
                sessionFactory.firstRoom = 0;
                propertyFactory.rooms = [];
                propertyFactory.roomAvailabilities = [];
            }
            $scope.getRooms();
            sessionFactory.forceRoomRefresh = false;
        }
    };
    $scope.getRooms = function(){
        // show the loader
        sessionFactory.isLoading = true;
        $scope.roomsHaveBeenLoaded = false;
        $http.get('/front-booking/api-room/',
            {
                params: {
                    bc: propertyFactory.id,
                    sid: sessionFactory.sid,
                    templateID: propertyFactory.template.id,
                    limit: $scope.loadingLimit,
                    firstRoom: sessionFactory.firstRoom,
                    adults: sessionFactory.selectedFilters.adults,
                    children: sessionFactory.selectedFilters.children,
                    infants: sessionFactory.selectedFilters.infants,
                    dateIn: $filter('date')(sessionFactory.selectedFilters.checkin,'yyyy-MM-dd'),
                    dateOut: $filter('date')(sessionFactory.selectedFilters.checkout, 'yyyy-MM-dd'),
                    format: 'json'
                }
            }
        )
        .success(function(data, status, headers, config){
            $scope.roomsHaveBeenLoaded = true;
            // check valid reposonse was returned
            if(typeof data.validCombos !== 'undefined') {
                // check closed dates
                session.propertyClosedOnStartDate = data.startDateClosed;
                session.propertyClosedOnEndDate = data.endDateClosed;
                // check minimum stay
                session.minimumStay = data.minimumStay;
                // updated the needle count
                if (data.validCombos.length === $scope.loadingLimit) {
                    sessionFactory.firstRoom += $scope.loadingLimit;
                    // check load more rooms
                    if(!data.remainingCombos){
                        sessionFactory.loadMore.rooms = false;
                    }
                } else {
                    sessionFactory.firstRoom += data.validCombos.length;
                    // disable to load more button
                    sessionFactory.loadMore.rooms = false;
                }
                // update the property's rooms details
                for (combo in data.validCombos) {
                    if (data.validCombos.hasOwnProperty(combo)) {

                        // Generate custom value object for each custom field
                        data.validCombos[combo]['customValues'] = {};
                        _.each(data.validCombos[combo].customFields, function(customField){
                            data.validCombos[combo].customValues[customField.id] = {id: null,rawValue: null,value: null};
                        });
                        propertyFactory.rooms.push(data.validCombos[combo]);
                    }
                }

                // update the property's room prices
                for (var price in data.validPricings) {
                    if (data.validPricings.hasOwnProperty(price)) {
                        propertyFactory.prices.push(data.validPricings[price]);
                    }
                }
                // update the property's room availabilities
                for (var availability in data.comboAvailabilities) {
                    if (data.comboAvailabilities.hasOwnProperty(availability)) {
                        propertyFactory.roomAvailabilities.push(data.comboAvailabilities[availability])
                    }
                }
            } else {
                sessionFactory.loadMore.rooms = false;
                $scope.showError('Whoops','<p>It appears that your session has expired.</p><p>Please try clearing your browser cache and refreshing</p>', true);
            }
            sessionFactory.propertyCloseDates = data.closedDates;
            sessionFactory.propertyClosedMessage = data.closedMessage;
            // hide the loader
            sessionFactory.isLoading = false;
        })
        .error(function(data, status, headers, config){
            $scope.logError('error retrieving rooms',{status: status, headers: headers});
            // display error to the user
            $scope.showError('Whoops','It appears that your session has expired. Please try clearing your browser cache and refreshing', true);
            sessionFactory.loadMore.rooms = false;
            // remove the loader
            sessionFactory.isLoading = false;
        });
    };
});